import { Trace } from "../../../telemetry/Trace";
import { dashboard } from "../../../telemetry/TraceLogging";
import { lazyLoadModule } from "../../lazyLoadModule";
const TelemetryModule = import(
/* webpackChunkName: "Telemetry-Chunk" */
"../../../telemetry/Telemetry");
export class WidgetTelemetryApi {
    constructor() {
        this._dmaPolicyApi = null;
    }
    getDMAPolicyEvaluatorApi() {
        var _a;
        if (!this._dmaPolicyApi) {
            this._dmaPolicyApi = (_a = window.__com_microsoft_dsh_widgetModelApiFactory) === null || _a === void 0 ? void 0 : _a.tryGetApi("dmapolicyevaluator", 1, 1);
        }
        return this._dmaPolicyApi;
    }
    setWebXTInteractionTelemetryEvent(widgetInstance, options) {
        const defaults = {
            actionType: "click",
            indexedDBInstanceId: widgetInstance.instanceId,
            name: "MS.News.Web.PageAction",
            pageName: "winp2dashstart",
            pageType: "dhp",
            product: "windowsdash",
            widgetDefinitionId: widgetInstance.widgetDefinitionId,
            widgetInstanceId: widgetInstance.widgetId,
        };
        return Object.assign(Object.assign({}, defaults), options);
    }
    updateOutlookProperty(widgetId, property) {
        let lowerWidgetName = widgetId === "com.microsoft.calendar" ? "calendar" : "todo";
        let upperWidgetName = widgetId === "com.microsoft.calendar" ? "Calendar" : "Todo";
        // No replace all function in ES2017
        let lowerCaseReplaced = property.replace("lower", lowerWidgetName);
        while (lowerCaseReplaced.search("lower") !== -1) {
            lowerCaseReplaced = lowerCaseReplaced.replace("lower", lowerWidgetName);
        }
        let allCasesReplaced = lowerCaseReplaced.replace("upper", upperWidgetName);
        while (allCasesReplaced.search("upper") !== -1) {
            allCasesReplaced = allCasesReplaced.replace("upper", upperWidgetName);
        }
        return allCasesReplaced;
    }
    updateEventProperties(event, addedProperties) {
        return Object.assign(Object.assign({}, event), addedProperties);
    }
    sendTelemetryEvent(event) {
        Trace.logEvent(dashboard, "SendTelemetryEvent", 1 /* information */, {
            event: event,
        });
        window.dispatchEvent(new CustomEvent(event.name !== undefined ? event.name : "", {
            detail: event,
        }));
    }
    sendPerformanceEvent(event) {
        Trace.logEvent(dashboard, "SendPerformanceEvent", 1 /* information */, {
            event: event,
        });
        window.dispatchEvent(new CustomEvent("PerformanceEvent", {
            detail: event,
        }));
    }
    markPerfEvent(eventName, level = 0 /* none */, payload) {
        if (!(payload instanceof Object) || Array.isArray(payload)) {
            payload = {
                payload: payload || "",
            };
        }
        lazyLoadModule(TelemetryModule).then((Telemetry) => {
            Telemetry.logEvent(dashboard, eventName, level, Object.assign({}, payload));
        });
    }
    async sendWebXTWidgetCardActionTelemetryAsync(instance, actionId, isNav) {
        // Only share 3P interaction data with WebXT if the policy is disabled
        const dmaPolicyApi = this.getDMAPolicyEvaluatorApi();
        if (dmaPolicyApi) {
            var isSharingRestricted = await dmaPolicyApi.isWidgetsRestrictedThirdPartyDataSharingEnabled();
            if (!isSharingRestricted) {
                // Telemetry event values provided to us by WebXT for a nav click scenario
                let event = this.setWebXTInteractionTelemetryEvent(instance, {
                    behavior: isNav ? 1 : 25,
                    headline: actionId,
                    lineage: instance.widgetId + (isNav ? ": widgetnav" : ": widgetnonnav"),
                    objectName: isNav ? "widgetnav" : "widgetnonnav",
                });
                this.sendTelemetryEvent(event);
            }
        }
    }
    sendWebXTWidgetVisibilityTelemetry(instance) {
        if (instance.isOutlookWidget()) {
            let event = this.setWebXTInteractionTelemetryEvent(instance, {
                actionType: "",
                contentType: 1,
                headline: this.updateOutlookProperty(instance.widgetId, "upper_Card"),
                name: "MS.News.Web.ContentView",
                objectName: this.updateOutlookProperty(instance.widgetId, "lower_cardactionmenu"),
                vertical: "office",
            });
            // Telemetry event values provided to us by WebXT for a non-nav click scenario
            this.sendTelemetryEvent(event);
        }
    }
    async sendWebXTWidgetActivationUrlTelemetryAsync(instance) {
        // Send signal if policy is not enabled or widgets is Outlook
        const dmaPolicyApi = this.getDMAPolicyEvaluatorApi();
        if (dmaPolicyApi) {
            var isSharingRestricted = await dmaPolicyApi.isWidgetsRestrictedThirdPartyDataSharingEnabled();
            if (!isSharingRestricted || instance.isOutlookWidget()) {
                // Telemetry event values provided to us by WebXT for a nav click scenario
                let clickEvent = this.setWebXTInteractionTelemetryEvent(instance, {
                    behavior: 1,
                    headline: instance.widgetRegistration.activationUrl,
                    lineage: instance.widgetId + ": destination",
                    objectName: "header",
                });
                if (instance.isOutlookWidget() && instance.widgetRegistration.activationUrl) {
                    let eventProperties = {
                        contentType: 1,
                        lineage: this.updateOutlookProperty(instance.widgetId, ">upperCard>header"),
                        vertical: "office",
                    };
                    clickEvent = this.updateEventProperties(clickEvent, eventProperties);
                }
                this.sendTelemetryEvent(clickEvent);
            }
        }
    }
    async sendWebXTWidgetActionMenuTelemetryAsync(instance, isActionMenuOpen) {
        // Send Outlook telemetry if action menu is open
        if (isActionMenuOpen && instance.isOutlookWidget()) {
            let visibilityEvent = this.setWebXTInteractionTelemetryEvent(instance, {
                actionType: "",
                contentType: 1,
                name: "MS.News.Web.ContentView",
                objectName: this.updateOutlookProperty(instance.widgetId, "lower_cardactionmenu"),
                vertical: "office",
            });
            this.sendTelemetryEvent(visibilityEvent);
        }
        // Click on [...]
        const dmaPolicyApi = this.getDMAPolicyEvaluatorApi();
        if (dmaPolicyApi) {
            var isSharingRestricted = await dmaPolicyApi.isWidgetsRestrictedThirdPartyDataSharingEnabled();
            if (!isSharingRestricted || instance.isOutlookWidget()) {
                let contextMenuEvent = this.setWebXTInteractionTelemetryEvent(instance, {
                    behavior: 12,
                    contentType: 1,
                    headline: undefined,
                    lineage: instance.widgetId + ": cardaction",
                    objectName: "cardaction",
                });
                if (instance.isOutlookWidget()) {
                    let eventProperties = {
                        lineage: this.updateOutlookProperty(instance.widgetId, ">upperCard>lower_cardaction"),
                        objectName: this.updateOutlookProperty(instance.widgetId, "lower_cardaction"),
                        vertical: "office",
                    };
                    contextMenuEvent = this.updateEventProperties(contextMenuEvent, eventProperties);
                }
                this.sendTelemetryEvent(contextMenuEvent);
            }
        }
    }
    async sendWebXTWidgetUnpinTelemetryAsync(instance) {
        const dmaPolicyApi = this.getDMAPolicyEvaluatorApi();
        if (dmaPolicyApi) {
            var isSharingRestricted = await dmaPolicyApi.isWidgetsRestrictedThirdPartyDataSharingEnabled();
            if (!isSharingRestricted || instance.isOutlookWidget()) {
                // Telemetry event values provided to us by WebXT for a unpin scenario
                let unpinClickEvent = this.setWebXTInteractionTelemetryEvent(instance, {
                    behavior: 6,
                    contentType: 1,
                    lineage: instance.widgetId + ": cardactionmenu>removewidget",
                    objectName: "removeWidget",
                });
                if (instance.isOutlookWidget()) {
                    let eventProperties = {
                        lineage: this.updateOutlookProperty(instance.widgetId, ">upperCard>lower_cardaction>lower_cardactionmenu>removewidget"),
                        vertical: "office",
                    };
                    unpinClickEvent = this.updateEventProperties(unpinClickEvent, eventProperties);
                }
                this.sendTelemetryEvent(unpinClickEvent);
            }
        }
    }
    async sendWebXTWidgetSizeChangeTelemetryAsync(instance, newSize) {
        const dmaPolicyApi = this.getDMAPolicyEvaluatorApi();
        if (dmaPolicyApi) {
            var isSharingRestricted = await dmaPolicyApi.isWidgetsRestrictedThirdPartyDataSharingEnabled();
            if (!isSharingRestricted || instance.isOutlookWidget()) {
                // Telemetry event values provided to us by WebXT for a size click scenario
                let sizeClickEvent = this.setWebXTInteractionTelemetryEvent(instance, {
                    behavior: 30,
                    contentType: 1,
                    headline: undefined,
                    lineage: instance.widgetId + ": cardactionmenu>" + newSize,
                    objectName: newSize,
                });
                if (instance.isOutlookWidget()) {
                    // Replace name with Calendar or Todo
                    let eventProperties = {
                        lineage: this.updateOutlookProperty(instance.widgetId, ">upperCard>lower_cardaction>lower_cardactionmenu>") + newSize,
                        vertical: "office",
                    };
                    sizeClickEvent = this.updateEventProperties(sizeClickEvent, eventProperties);
                }
                this.sendTelemetryEvent(sizeClickEvent);
            }
        }
    }
}
